import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { resetCart } from "../../redux/orebiSlice";
import { emptyCart } from "../../assets/images/index";
import { formatPrice } from "../../constants/funciones";
import Swal from "sweetalert2";
import { loadUserConfig, addEvent, AgregarPresupuesto } from "../../constants/config";
import { UserConfigContext } from "../../context/UserConfigContext";
import { sendOrder } from "../../constants/order";
import { emailpedido } from "../../constants/products";
import { getDiscountedUnitPrice, getProductBasePrice, getQuantityDiscount } from "../../constants/cartDiscounts";
import { ImBin } from "react-icons/im";
import CryptoJS from "crypto-js";
import { deleteItem, drecreaseQuantity, increaseQuantity } from "../../redux/orebiSlice";

// import iconoMP from "../../assets/images/mercadopago.png"; // tu imagen local
import iconoMP from "../../assets/images/mercadopago.jpg"; // tu imagen local

const Cart = () => {
  const loggedUserData = JSON.parse(localStorage.getItem("user")) || {};
  const userType = loggedUserData?.data?.empresas?.[0]?.tipo || "";
  const userPerfil = loggedUserData?.data?.empresas?.[0]?.perfil || "";
  const { id_usuario = "", nrocli = "" } = loggedUserData?.data?.cliente || {};
  const { ip = "", dispositivo = "", tipo_dispositivo = "" } = loggedUserData?.data || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const products = useSelector((state) => state.orebiReducer.products);

  const [subTotalAmt, setSubTotalAmt] = useState(0);
  const [totalIva, setTotalIva] = useState(0);
  const [shippingCharge, setShippingCharge] = useState(0);
  const [totalAmt, setTotalAmt] = useState(0);
  const [empresaId, setEmpresaId] = useState(0);
  const [Simbolo, setSimbolo] = useState("");
  const [Cotizacion, setCotizacion] = useState(1);
  const [Codigo, setCodigo] = useState("");
  const [Ivainc, setIvainc] = useState(0);
  const [showForm, setShowForm] = useState(false);

  const [showPresupuesto, setShowPresupuesto] = useState(false);
  const [porcentaje, setPorcentaje] = useState("");
  const [presupuestoForm, setPresupuestoForm] = useState({
    nombre: "",
    direccion: "",
    ciudad: "",
    pais: "AR",
    provincia: "",
    codigoPostal: "",
    telefono: "",
    email: "",
    fee: loggedUserData?.data?.cliente?.fee || 0,
    dias_venc_presup: 7,
  });
  const [productosPresupuesto, setProductosPresupuesto] = useState([]);
  const [subtotalPresupuesto, setSubtotalPresupuesto] = useState(0);
  const [ivaPresupuesto, setIvaPresupuesto] = useState(0);
  const [totalPresupuesto, setTotalPresupuesto] = useState(0);

  const { config1, config2 } = useContext(UserConfigContext);
  const location = useLocation();
  const isLoggedIn = !!loggedUserData?.data?.user;

  const [showCheckoutModal, setShowCheckoutModal] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    nombre: "",
    direccion: "",
    localidad: "",
    codigoPostal: "",
    telefono: "",
    provincia: "",
    pais: "AR",
    inscripcion: "Consumidor Final",
    s_tipo_doc: "DNI",
    cuit: "",
  });

  const [buscarCliente, setBuscarCliente] = useState("");
  const [clientes, setClientes] = useState([]);
  const [loadingClientes, setLoadingClientes] = useState(false);

  const buscarClientesAPI = async (valor) => {
    setBuscarCliente(valor);

    if (valor.length < 3) {
      setClientes([]);
      return;
    }

    try {
      setLoadingClientes(true);

      // const response = await fetch(
      //   `https://tu-api.com/clientes?q=${valor}`
      // );

      const response = await fetch(`${process.env.REACT_APP_URL_APIHN24}/clientes?q=${valor}`, {
        method: "GET",
        headers: {
          'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'),
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      setClientes(data);
    } catch (error) {
      console.error("Error buscando clientes", error);
    } finally {
      setLoadingClientes(false);
    }
  };

  // --- CALCULO PRODUCTOS PRESUPUESTO ---
  useEffect(() => {
    if (showPresupuesto && products.length > 0) {
      const fee = presupuestoForm.fee !== undefined ? Number(presupuestoForm.fee) || 0 : 0;

      setProductosPresupuesto((prev = []) => {
        // crear mapa por codigo para preservar ediciones previas
        const prevMap = {};
        prev.forEach((p) => {
          const key = p.codigo || p.Codigo || p.Sku || p.id || "";
          if (key) prevMap[key] = p;
        });

        return products.map((p) => {
          const quantity = p.quantity || 1;
          const precioOriginal = getProductBasePrice(p);
          const descuento = getQuantityDiscount(p, quantity);
          const precioConDescuento = getDiscountedUnitPrice(p, quantity);
          const ivaItem = p.iva ?? 0;
          const key = p.codigo || p.Codigo || p.Sku || p.id || "";

          // si ya existía y estaba modificado, preservamos su precio y flag
          const prevItem = key ? prevMap[key] : null;
          const fueModificado = prevItem?.precioModificado === true;

          const basePrecio = fueModificado ? prevItem.precio : precioConDescuento;
          const precioConFee = fueModificado
            ? basePrecio
            : fee > 0
              ? precioConDescuento * (1 + fee / 100)
              : precioConDescuento;

          const totalProducto = precioConFee * quantity;
          const subtotal = totalProducto / (1 + ivaItem / 100);
          const ivaProducto = totalProducto - subtotal;

          return {
            ...p,
            precioOriginal,
            precioConDescuento,
            descuentoAplicado: descuento.porcentaje,
            precio: precioConFee,
            precioInput: Number(precioConFee || 0).toFixed(2),
            precioModificado: !!fueModificado,
            img: p.img || "",
            Descripcion: p.Descripcion || p.nombre || "",
            quantity,
            codigo: p.codigo || p.Codigo || "",
            subtotal,
            ivaProducto,
            totalProducto,
          };
        });
      });
    }
  }, [showPresupuesto, products, presupuestoForm.fee]);


  // --- RECALCULO TOTALES ---
  useEffect(() => {
    const subtotalTotal = productosPresupuesto.reduce((acc, p) => acc + p.subtotal, 0);
    const ivaTotal = productosPresupuesto.reduce((acc, p) => acc + p.ivaProducto, 0); // usar ivaProducto
    const totalPedido = productosPresupuesto.reduce((acc, p) => acc + p.totalProducto, 0);

    setSubtotalPresupuesto(subtotalTotal);
    setIvaPresupuesto(ivaTotal);
    setTotalPresupuesto(totalPedido);
  }, [productosPresupuesto]);

  // --- CONFIGURACION INICIAL ---
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setEmpresaId(config1?.empresa?.id ?? 0);
        setIvainc(config1?.empresa?.ivainc ?? 0);
        setSimbolo(config1?.monedaEcommerce?.monedaSimbolo ?? "$");
        setCodigo(config1?.monedaEcommerce?.monedaCodigo ?? "PESO");
        setCotizacion(config1?.monedaEcommerce?.monedaCotizacion ?? 1);
      } catch (error) {
        console.error("Error al cargar configuración:", error);
      }
    };
    fetchConfig();
  }, []);

  // --- CALCULO DE TOTALES DEL CARRITO ---
  useEffect(() => {
    if (!Array.isArray(products) || products.length === 0) {
      setSubTotalAmt(0);
      setTotalIva(0);
      setTotalAmt(0);
      return;
    }

    const subtotal = products.reduce((acc, item) => {
      const precio = getDiscountedUnitPrice(item, item.quantity);
      const quantity = item.quantity || 1;
      return acc + (Ivainc == 1 ? precio * quantity : precio * quantity / (1 + (item.iva ?? 0) / 100));
    }, 0);

    const iv = products.reduce((acc, item) => {
      const precio = getDiscountedUnitPrice(item, item.quantity);
      const quantity = item.quantity || 1;
      const base = Ivainc == 1 ? precio * quantity : precio * quantity / (1 + (item.iva ?? 0) / 100);
      return acc + ((Ivainc == 1) ? base * (item.iva ?? 0) / 100 : precio * quantity - base);
    }, 0);

    setSubTotalAmt(subtotal);
    setTotalIva(iv);
    setTotalAmt(subtotal + iv);
  }, [Ivainc, products]);

  useEffect(() => {
    setShippingCharge(0);
  }, [totalAmt]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "pais" ? { provincia: "" } : {})
    }));
  };

  const handleImageClick = (item) => {
    const cod = item.codigo.replace(/\//g, "|");
    navigate(`/product/${cod}`, { state: { item } });
  };

  const provinciasFiltradas = config1.provincias.filter(
    (provincia) => provincia.cod_pais === formData.pais
  );

  const handleProcessOrder = async () => {
    const camposObligatorios = ["email", "nombre", "inscripcion", "s_tipo_doc", "cuit"];
    const isFormComplete = camposObligatorios.every(
      (campo) => formData[campo]?.trim() !== ""
    );
    if (!isLoggedIn && !isFormComplete) {
      Swal.fire({
        icon: "warning",
        title: "Formulario incompleto",
        text: "Debés iniciar sesión o completar todos los campos del formulario para continuar.",
      });
      return;
    }
    const cliente = isFormComplete ? formData : loggedUserData.data.user;
    const email = (loggedUserData?.data?.user?.email || formData.email)?.trim();
    try {
      const notas = document.getElementById("notas")?.value || "";
      const response = await sendOrder(cliente, products, empresaId, Codigo, Cotizacion, notas, Ivainc);
      if (response.error) {
        Swal.fire({
          icon: "error",
          title: "Error al procesar la orden",
          html: Array.isArray(response.message)
            ? response.message.join("<br>")
            : response.message || "Inténtalo de nuevo más tarde.",
        });
        return;
      }
      const order_id = response.order_id;
      const nro_int_ped = response.nro_interno;
      const eventResults = await Promise.all([
        ...products.map((prod) =>
          addEvent(
            id_usuario,
            nrocli,
            ip,
            dispositivo,
            tipo_dispositivo,
            12,
            order_id,
            prod.codigo,
            prod.quantity,
            '',
            1,
            nro_int_ped
          )
        ),
        addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 8, order_id, '', 1, '', 0, nro_int_ped),
      ]);
      if (eventResults.some((result) => result === null)) {
        console.warn("Uno o mas eventos del pedido no se pudieron registrar.");
      }
      const ahora = new Date();
      const fecha = ahora.toLocaleDateString("es-AR");
      const hora = ahora.toLocaleTimeString("es-AR");
      const nro_sesion = Math.floor(100000 + Math.random() * 900000);
      const fechaHora = `${fecha} ${hora}`;
      const hashFechaHora = CryptoJS.MD5(fechaHora).toString();
      const sessionFinal = `${hashFechaHora} - ${nro_sesion}`;
      localStorage.setItem("session", sessionFinal);
      dispatch(resetCart({ event: 1 }));
      Swal.fire({ icon: "success", title: response.message || "Orden procesada exitosamente", text: "Volver a la Tienda..." })
        .then(async () => {
          try {
            await emailpedido(response.nro_interno, email);
          } catch (emailError) {
            Swal.fire({
              icon: "error",
              title: "Error al enviar el correo",
              text: "El Pedido fue Procesado, pero no se pudo enviar el correo.",
            });
          }
          navigate("/");
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Hubo un error al procesar la orden",
        text: error.response?.data?.message || "Inténtalo de nuevo más tarde.",
      });
    }
  };

  const limpiarPresupuesto = () => {
    setPresupuestoForm({
      nombre: "",
      direccion: "",
      ciudad: "",
      pais: "",
      provincia: "",
      codigoPostal: "",
      telefono: "",
      email: "",
      fee: 0,
      dias_venc_presup: 7
    });
    setProductosPresupuesto([]);
    setSubtotalPresupuesto(0);
    setIvaPresupuesto(0);
    setTotalPresupuesto(0);
    setPorcentaje("");
    dispatch(resetCart());
  };

  const generarPresupuesto = async () => {
    const incluye_iva = Ivainc === 1 ? 0 : 1;
    const order_id = Math.floor(100000 + Math.random() * 900000).toString();
    const email = (loggedUserData?.data?.user?.email || formData.email)?.trim();
    const nrocli = loggedUserData?.data?.cliente?.nrocli || "";
    
    //validaciones
    if (!presupuestoForm.nombre.trim()) {
      Swal.fire({ icon: "warning", title: "El Nombre es Obligatorio" });
      return;
    }

    if (!nrocli.trim()) {
      Swal.fire({ icon: "warning", title: "Falta el nro de Cliente o es un Operador" });
      return;
    }

    const orderData = {
      order: {
        order_id: '',
        id_usuario: loggedUserData?.data?.user?.id || 0,
        nrocli: nrocli,
        doc_type: loggedUserData?.data?.user?.s_tipo_doc || "DNI",
        Notas: document.getElementById("notas2")?.value || "",
        empresa: empresaId.toString(),
        deposito: "01",
        moneda: Codigo || "PES",
        cotizacion: Cotizacion,
        punto: "00001",
        vendedor: "EC",
        DNI: loggedUserData?.data?.user?.cuit || "",
        ApellidoyNombre: presupuestoForm.nombre,
        Direccion: presupuestoForm.direccion,
        Ciudad: presupuestoForm.ciudad,
        Provincia: presupuestoForm.provincia,
        CodigoPostal: presupuestoForm.codigoPostal,
        Pais: presupuestoForm.pais,
        Email: presupuestoForm.email,
        Telefono: presupuestoForm.telefono,
        incluye_iva: incluye_iva,
        dias_vigencia: presupuestoForm.dias_venc_presup
      },
      itemDetails: productosPresupuesto.map((p) => ({
        Sku: p.codigo || p.Codigo || "",
        Cantidad: p.quantity,
        Descripcion: p.Descripcion,
        Descuento: p.descuentoAplicado || 0,
        PrecioOriginal: p.precioOriginal,
        PrecioConDescuento: p.precioConDescuento,
        Precio: Number(p.precio || 0).toFixed(2)
      })),
    };
    try {
      // console.log(orderData);
      const response = await AgregarPresupuesto(orderData);
      if (response.status) {
        Swal.fire({ icon: "success", title: "Presupuesto generado", text: response.message });

        if (response.url_comprobante?.trim()) window.open(response.url_comprobante, "_blank");

        try {
          await emailpedido(response.nro_interno, email);
        } catch (emailError) {
          Swal.fire({
            icon: "error",
            title: "Error al enviar el correo",
            text: "El Presupuesto fue Procesado, pero no se pudo enviar el correo.",
          });
        }

        limpiarPresupuesto();
        setShowPresupuesto(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error al Generar Presupuesto",
          text: Array.isArray(response.message) ? response.message.join(", ") : response.message
        });
      }
    } catch (error) {
      Swal.fire({ icon: "error", title: "Error en el servidor", text: error.message || "Intente nuevamente más tarde." });
    }
  };

  // --- Modal Presupuesto actualizado ---
  return (
    <div className="max-w-7xl mx-auto px-4">
      <h1 className="text-2xl md:text-4xl font-bold mt-6 mb-4">Mi pedido</h1>

      {/* {userType === "o" && userPerfil === "4000" && (
        <div className="mb-4">
          <label className="block font-semibold mb-2">
            Buscar cliente
          </label>

          <input
            type="text"
            value={buscarCliente}
            onChange={(e) => buscarClientesAPI(e.target.value)}
            placeholder="Nombre, código o CUIT"
            className="w-full border rounded-md p-2"
          />

          {loadingClientes && (
            <p className="text-sm text-gray-500 mt-1">
              Buscando...
            </p>
          )}

          {clientes.length > 0 && (
            <div className="border rounded-md mt-2 max-h-60 overflow-y-auto">
              {clientes.map((cliente) => (
                <div
                  key={cliente.id}
                  className="p-2 hover:bg-gray-100 cursor-pointer border-b"
                  onClick={() => {
                    setPresupuestoForm({
                      ...presupuestoForm,
                      nombre: cliente.nombre || "",
                      direccion: cliente.direccion || "",
                      ciudad: cliente.ciudad || "",
                      telefono: cliente.telefono || "",
                      email: cliente.email || "",
                      codigoPostal: cliente.codigoPostal || "",
                    });

                    setBuscarCliente(cliente.nombre);
                    setClientes([]);
                  }}
                >
                  <div className="font-semibold">
                    {cliente.nombre}
                  </div>

                  <div className="text-sm text-gray-500">
                    {cliente.cuit}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )} */}

      {!isLoggedIn && (
        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6 rounded-md">
          <div
            className="cursor-pointer flex justify-between items-center"
            onClick={() => setShowForm(!showForm)}
          >
            <p className="font-semibold">
              Debés estar registrado para poder hacer un pedido. Haz clic aquí para registrarte o{" "}
              <Link to="/signin" className="text-blue-600 underline">
                iniciar sesión
              </Link>.
            </p>

            <span className="ml-2 text-xl">{showForm ? "▲" : "▼"}</span>
          </div>
          {showForm && (
            <div className="mt-4">
              <form className="space-y-4 p-4 rounded-md shadow-md">
                <div className="flex flex-col md:flex-row md:space-x-4">
                  <div className="flex-1 mt-4 md:mt-0">
                    <label className="block text-sm font-medium text-gray-700">Correo electrónico</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      required
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Nombre</label>
                    <input
                      type="text"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleInputChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Dirección</label>
                    <input
                      type="text"
                      name="direccion"
                      value={formData.direccion}
                      onChange={handleInputChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Localidad</label>
                    <input
                      type="text"
                      name="localidad"
                      value={formData.localidad}
                      onChange={handleInputChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Código Postal</label>
                    <input
                      type="text"
                      name="codigoPostal"
                      value={formData.codigoPostal}
                      onChange={handleInputChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Teléfono</label>
                    <input
                      type="text"
                      name="telefono"
                      value={formData.telefono}
                      onChange={handleInputChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">País</label>
                    <select
                      name="pais"
                      value={formData.pais}
                      onChange={handleInputChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    >
                      {config1.paises?.map((pais) => (
                        <option key={pais.id_pais} value={pais.id_pais}>
                          {pais.pais}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Provincia</label>
                    <select
                      name="provincia"
                      value={formData.provincia}
                      onChange={handleInputChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"

                    >
                      <option value="">Selecciona una Provincia</option>
                      {provinciasFiltradas.length === 0 ? (
                        <option disabled>No hay Provincias disponibles</option>
                      ) : (
                        provinciasFiltradas.map((prov) => (
                          <option key={prov.pcia} value={prov.pcia}>
                            {prov.nombre}
                          </option>
                        ))
                      )}
                    </select>

                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700">Inscripción ARCA</label>

                    <select
                      value={formData.inscripcion}
                      onChange={(e) => setFormData({ ...formData, inscripcion: e.target.value })}
                      className="mr-2 border border-gray-300 rounded p-2 w-full"
                    >
                      <option value="0">Seleccione Condición Impositiva</option>
                      {config1.cond_impositiva.map((cond) => (
                        <option key={cond.id_respiva} value={cond.id_respiva}>
                          {cond.Descripcion}
                        </option>
                      ))}
                    </select>

                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Tipo de Documento</label>
                    <select
                      name="s_tipo_doc"
                      value={formData.s_tipo_doc}
                      onChange={handleInputChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    >
                      <option>DNI</option>
                      <option>CUIT</option>
                      <option>Pasaporte</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Número de Documento</label>
                    <input
                      type="text"
                      name="cuit"
                      value={formData.cuit}
                      onChange={handleInputChange}
                      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                    />
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      )}

      {products.length > 0 ? (
        <div className="pb-20">
          <div className="overflow-x-auto">
            <table className="w-full border-collapse mb-4 text-sm md:text-lg">
              <thead>
                <tr className="bg-gray-100 text-primeColor">
                  <th className="text-left p-2">Producto</th>
                  <th className="text-right p-2">Precio</th>
                  <th className="text-center p-2">Cantidad</th>
                  <th className="text-right p-2">Descuento</th>
                  <th className="text-right p-2">Total</th>
                </tr>
              </thead>
              <tbody>
                {products.map((item) => {
                  const discount = getQuantityDiscount(item, item.quantity);
                  const price = getDiscountedUnitPrice(item, item.quantity);
                  const price1 = (Ivainc === 1 ? price * (1 + (item.iva ?? 0) / 100) : price);
                  const basePrice = price * item.quantity;
                  const totalFinal = Ivainc === 1
                    ? basePrice * (1 + (item.iva ?? 0) / 100)
                    : basePrice;
                  return (
                    <tr key={item.codigo} className="border-b">
                      <td className="flex items-center gap-4 p-4">
                        <ImBin
                          onClick={() => dispatch(deleteItem(item.codigo))}
                          className="text-primeColor hover:text-red-500 duration-300 cursor-pointer"
                        />
                        <img
                          src={item.img}
                          alt={item.Descripcion}
                          className="w-10 h-10 md:w-14 md:h-14 object-contain cursor-pointer"
                          onClick={() => handleImageClick(item)}
                        />

                        <span className="text-sm md:text-base">
                          {item.Descripcion}
                        </span>
                      </td>
                      <td className="text-right p-2">
                        {item.simbolo} {formatPrice(price1)}
                      </td>
                      <td className="text-center">
                        <div className="flex items-center justify-center gap-2">
                          <button
                            onClick={() =>
                              dispatch(
                                drecreaseQuantity({ codigo: item.codigo })
                              )
                            }
                            className="px-2 py-1 md:px-3 md:py-1 border rounded-lg hover:bg-gray-200 duration-200"
                          >
                            -
                          </button>
                          <span>{item.quantity}</span>
                          <button
                            onClick={() =>
                              dispatch(
                                increaseQuantity({ codigo: item.codigo })
                              )
                            }
                            className="px-2 py-1 md:px-3 md:py-1 border rounded-lg hover:bg-gray-200 duration-200"
                          >
                            +
                          </button>
                        </div>
                      </td>
                      <td className="text-right p-2">
                        {discount.porcentaje > 0
                          ? `${formatPrice(discount.porcentaje)} %`
                          : formatPrice(0)}
                      </td>                      
                      <td className="text-right p-2">
                        {item.simbolo} {formatPrice(totalFinal)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="flex flex-wrap gap-4 justify-between">
            <button
              type="button"
              onClick={() => dispatch(resetCart())}
              className="py-2 px-6 bg-red-500 text-white font-semibold uppercase hover:bg-red-700 duration-300"
            >
              Vaciar carrito
            </button>
            <Link to="/">
              <button className="py-2 px-6 bg-green-500 text-white font-semibold uppercase hover:bg-green-700 duration-300">
                Seguir comprando
              </button>
            </Link>
          </div>

          <div className="flex flex-col md:flex-row mt-8 gap-4 items-stretch">
            {/* Área de Notas */}
            <div className="flex-1 flex flex-col">
              <label
                htmlFor="notas"
                className="block text-base md:text-lg font-semibold mb-2"
              >
                Notas:
              </label>
              <textarea
                id="notas"
                className="w-full flex-grow border border-gray-300 rounded-md p-2 resize-none focus:outline-none focus:ring-2 focus:ring-primeColor"
                placeholder="Escribe tus notas aquí..."
              ></textarea>
            </div>

            {/* Área de Totales */}
            <div className="w-full md:w-96 flex flex-col">
              <h1 className="text-lg md:text-2xl font-semibold text-right">Total</h1>
              <div className="border border-gray-400 mt-4 p-4 flex-grow">
                <p className="flex justify-between mb-2">
                  Subtotal
                  <span>
                    {/* {Simbolo} {formatPrice(totalAmt)} */}
                    {Simbolo} {formatPrice(subTotalAmt)}
                  </span>
                </p>
                {/* <p className="flex justify-between mb-2">
        Cargo de envío
        <span>
          {Simbolo} {formatPrice(shippingCharge)}
        </span>
      </p> */}
                <p className="flex justify-between mb-2">
                  IVA Incluido
                  <span>
                    {Simbolo} {formatPrice(totalIva)}
                  </span>
                </p>
                <p className="flex justify-between font-bold">
                  Total
                  <span>
                    {Simbolo} {formatPrice(totalAmt + shippingCharge)}
                  </span>
                </p>
              </div>

              <div className="flex gap-2 mt-4">

                {(config2?.vista.pago_enlinea === 1 && Number(loggedUserData?.data?.cliente.habilitacc) === 0) ? (
                  <>
                    {/* Botón principal Finalizar Pedido */}

                    <button
                      // onClick={() => setShowCheckoutModal(true)}

                      onClick={() => {
                        const notas = document.getElementById("notas")?.value || "";
                        navigate("/checkout", {
                          state: {
                            products,
                            shippingCharge,
                            total: totalAmt + shippingCharge,
                            notas,
                            formData,
                          },
                        })
                      }
                      }
                      className="w-full py-2 bg-yellow-500 text-white hover:bg-yellow-600 duration-300"
                    >
                      Finalizar pedido
                    </button>

                    {/* Modal con Checkout y QR */}
                    {showCheckoutModal && (
                      <div
                        className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50"
                      // onClick={() => setShowCheckoutModal(false)}
                      >
                        <div
                          className="bg-white rounded-xl shadow-lg p-6 w-[90%] max-w-md relative"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <h2 className="text-xl font-semibold mb-4 text-center">Elegí cómo finalizar tu pedido</h2>

                          <div className="flex flex-col gap-3">
                            {/* Botón Checkout */}
                            <button
                              onClick={() => {
                                const camposObligatorios = ["email", "nombre", "inscripcion", "s_tipo_doc", "cuit"];
                                const isFormComplete = camposObligatorios.every(
                                  (campo) => formData[campo]?.trim() !== ""
                                );

                                if (!isLoggedIn && !isFormComplete) {
                                  Swal.fire({
                                    icon: "warning",
                                    title: "Formulario incompleto",
                                    text: "Debés iniciar sesión o completar todos los campos del formulario para ir al checkout.",
                                  });
                                  return;
                                }

                                const notas = document.getElementById("notas")?.value || "";
                                navigate("/checkout", {
                                  state: {
                                    products,
                                    shippingCharge,
                                    total: totalAmt + shippingCharge,
                                    notas,
                                    formData,
                                  },
                                });
                              }}
                              // style={{
                              //   display: "flex",
                              //   alignItems: "center",
                              //   gap: "8px",
                              //   padding: "8px 12px",
                              //   border: "1px solid #ccc",
                              //   borderRadius: "8px",
                              //   cursor: "pointer",
                              //   background: "#f8f8f8",
                              // }}
                              // className="w-full py-2 bg-green-500 text-white rounded hover:bg-green-600 duration-300"
                              className="w-full h-50 py-2 text-white rounded"
                            >
                              {/* Ir al Checkout */}
                              <img src={iconoMP} alt="Mercado Pago" height="50%" />
                            </button>

                            {/* Botón QR */}
                            {/* Botón QR */}
                            <button
                              onClick={() => {
                                Swal.fire({
                                  icon: "info",
                                  title: "Funcionalidad en desarrollo",
                                  text: "El pago por QR estará disponible próximamente.",
                                });
                              }}
                              className="w-full py-2 bg-blue-500 text-white rounded hover:bg-blue-600 duration-300"
                            >
                              Pago con QR
                            </button>

                            {/* Cerrar */}
                            <button
                              onClick={() => setShowCheckoutModal(false)}
                              className="w-full py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 duration-300"
                            >
                              Cancelar
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                  </>
                ) : (
                  <>
                    <button
                      onClick={handleProcessOrder}
                      className="w-full py-2 bg-blue-500 text-white hover:bg-blue-700 duration-300"
                    >
                      Generar Pedido
                    </button>

                    {/* Mostrar Presupuesto solo si generar_presupuesto === 1  {config2?.vista.genera_presupuesto === 1 && (*/}

                    {config2?.vista.genera_presupuesto === 1 && (
                      <button
                        onClick={() => setShowPresupuesto(true)}
                        className="w-full py-2 bg-gray-500 text-white hover:bg-gray-700 duration-300"
                      >
                        Presupuesto
                      </button>
                    )}



                  </>
                )}
              </div>



            </div>
          </div>



        </div>
      ) : (
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.4 }}
          className="flex flex-col items-center gap-4 pb-20"
        >
          <img
            className="w-64 rounded-lg"
            src={emptyCart}
            alt="Carrito vacío"
          />
          <div className="text-center">
            <p className="mb-4">Tu carrito está vacío.</p>
            <Link to="/">
              <button className="bg-primeColor rounded-md px-6 py-2 hover:bg-black text-white">
                Volver a la tienda
              </button>
            </Link>
          </div>
        </motion.div>
      )}


      {showPresupuesto && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50"
          onClick={() => setShowPresupuesto(false)}
        >
          <div
            className="bg-white rounded-xl shadow-lg p-6 w-[95%] max-w-6xl relative overflow-y-auto max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-2xl font-semibold mb-4">Generar presupuesto</h2>

            {/* Formulario cliente */}
            <div className="grid gap-4 mb-4">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <input
                  type="text"
                  placeholder="Nombre"
                  className="border rounded-md p-2"
                  value={presupuestoForm.nombre}
                  onChange={(e) =>
                    setPresupuestoForm({ ...presupuestoForm, nombre: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Dirección"
                  className="border rounded-md p-2"
                  value={presupuestoForm.direccion}
                  onChange={(e) =>
                    setPresupuestoForm({ ...presupuestoForm, direccion: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Ciudad"
                  className="border rounded-md p-2"
                  value={presupuestoForm.ciudad || ""}
                  onChange={(e) =>
                    setPresupuestoForm({ ...presupuestoForm, ciudad: e.target.value })
                  }
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <input
                  type="text"
                  placeholder="Teléfono"
                  className="border rounded-md p-2"
                  value={presupuestoForm.telefono}
                  onChange={(e) =>
                    setPresupuestoForm({ ...presupuestoForm, telefono: e.target.value })
                  }
                />
                <input
                  type="email"
                  placeholder="Email"
                  className="border rounded-md p-2"
                  value={presupuestoForm.email}
                  onChange={(e) =>
                    setPresupuestoForm({ ...presupuestoForm, email: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Código Postal"
                  className="border rounded-md p-2"
                  value={presupuestoForm.codigoPostal || ""}
                  onChange={(e) =>
                    setPresupuestoForm({ ...presupuestoForm, codigoPostal: e.target.value })
                  }
                />
                {/* País */}
                <select
                  className="border rounded-md p-2"
                  value={presupuestoForm.pais}
                  onChange={(e) =>
                    setPresupuestoForm({
                      ...presupuestoForm,
                      pais: e.target.value,
                      provincia: "", // reset provincia
                    })
                  }
                >
                  {config1.paises?.map((pais) => (
                    <option key={pais.id_pais} value={pais.id_pais}>
                      {pais.pais}
                    </option>
                  ))}
                </select>
                {/* Provincia */}
                <select
                  className="border rounded-md p-2"
                  value={presupuestoForm.provincia || ""}
                  onChange={(e) =>
                    setPresupuestoForm({ ...presupuestoForm, provincia: e.target.value })
                  }
                >
                  <option value="">Selecciona una provincia</option>
                  {config1.provincias
                    .filter((prov) => prov.pais === presupuestoForm.pais)
                    .map((prov) => (
                      <option key={prov.pcia} value={prov.pcia}>
                        {prov.nombre}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            {/* Fecha vencimiento + Fee */}
            <div className="flex justify-between items-center mb-4 gap-4">
              <div className="flex items-center gap-2">
                <label>Días de vigencia:</label>
                <input
                  type="number"
                  min="1"
                  value={presupuestoForm.dias_venc_presup}
                  onChange={(e) =>
                    setPresupuestoForm({ ...presupuestoForm, dias_venc_presup: e.target.value })
                  }
                  className="border rounded-md p-2 w-20"
                />
                <input
                  type="text"
                  readOnly
                  className="border rounded-md p-2 text-center"
                  value={(() => {
                    const dias = Number(presupuestoForm.dias_venc_presup) || 7;
                    const hoy = new Date();
                    hoy.setDate(hoy.getDate() + dias);
                    return hoy.toISOString().split("T")[0];
                  })()}
                />
              </div>

              <div className="flex items-center gap-2">
                <label>% Aumento (Fee):</label>
                <input
                  type="text"
                  value={presupuestoForm.fee}
                  onChange={(e) => {
                    const valorTexto = e.target.value.replace(",", ".");
                    const nuevoFee = parseFloat(valorTexto) || 0;
                    setPresupuestoForm({ ...presupuestoForm, fee: valorTexto });

                    setProductosPresupuesto((prev) =>
                      prev.map((p) => {
                        // Si el precio fue modificado manualmente, lo respetamos
                        const descuento = getQuantityDiscount(p, p.quantity);
                        const precioConDescuento = getDiscountedUnitPrice(p, p.quantity);
                        const precioBase = p.precioModificado ? p.precio : precioConDescuento;
                        const precioConFee = nuevoFee > 0 ? precioBase * (1 + nuevoFee / 100) : precioBase;

                        const totalProducto = precioConFee * p.quantity;
                        const subtotal = totalProducto / (1 + (p.iva ?? 0) / 100);
                        const ivaProducto = totalProducto - subtotal;

                        return {
                          ...p,
                          precioOriginal: getProductBasePrice(p),
                          precioConDescuento,
                          descuentoAplicado: descuento.porcentaje,
                          precio: precioConFee,
                          precioInput: Number(precioConFee || 0).toFixed(2),
                          subtotal,
                          ivaProducto,
                          totalProducto,
                          precioModificado: false, // si toco fee, el precio ya no está modificado manualmente
                        };
                      })
                    );
                  }}
                  className="border rounded-md p-2 text-right"
                />

              </div>
            </div>

            {/* Tabla de productos editable */}
            <div className="overflow-x-auto mb-4">
              <table className="w-full border-collapse text-sm md:text-base">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-2 text-left">Imagen</th>
                    <th className="p-2 text-left">Producto</th>
                    <th className="p-2 text-right">Precio</th>
                    <th className="p-2 text-center">Cantidad</th>
                    <th className="p-2 text-right">Descuento</th>
                    <th className="p-2 text-right">Sub Total</th>
                  </tr>
                </thead>
                <tbody>
                  {productosPresupuesto.map((item, i) => (
                    <tr key={i} className="border-b">
                      <td className="p-2">
                        {item.img && (
                          <img
                            src={item.img}
                            alt={item.Descripcion}
                            className="w-16 h-16 object-cover rounded"
                          />
                        )}
                      </td>
                      <td className="p-2">{item.Descripcion}</td>
                      <td className="p-2 text-right">
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={item.precioInput ?? Number(item.precio || 0).toFixed(2)}
                          className="border rounded-md p-2 text-right"
                          onChange={(e) => {
                            const valor = e.target.value;
                            const nuevoPrecio = valor === "" ? 0 : parseFloat(valor) || 0;
                            setProductosPresupuesto((prev) =>
                              prev.map((p, idx) => {
                                if (idx !== i) return p;
                                const cantidad = p.quantity || 1;
                                const totalProducto = nuevoPrecio * cantidad;
                                const subtotal = totalProducto / (1 + (p.iva ?? 0) / 100);
                                const ivaProducto = totalProducto - subtotal;
                                return {
                                  ...p,
                                  precio: nuevoPrecio,
                                  precioInput: valor,
                                  precioModificado: true,
                                  subtotal,
                                  ivaProducto,
                                  totalProducto,
                                };
                              })
                            );
                          }}
                          onBlur={() => {
                            setProductosPresupuesto((prev) =>
                              prev.map((p, idx) => {
                                if (idx !== i) return p;
                                // Si el precio quedó vacío o 0, volver al original
                                if (!p.precio || p.precio <= 0) {
                                  const cantidad = p.quantity || 1;
                                  const fee = Number(presupuestoForm.fee) || 0;
                                  const precioOriginal = getProductBasePrice(p);
                                  const descuento = getQuantityDiscount(p, cantidad);
                                  const precioConDescuento = getDiscountedUnitPrice(p, cantidad);
                                  const precio = fee > 0 ? precioConDescuento * (1 + fee / 100) : precioConDescuento;
                                  const totalProducto = precio * cantidad;
                                  const subtotal = totalProducto / (1 + (p.iva ?? 0) / 100);
                                  const ivaProducto = totalProducto - subtotal;
                                  return {
                                    ...p,
                                    precioOriginal,
                                    precioConDescuento,
                                    descuentoAplicado: descuento.porcentaje,
                                    precio,
                                    precioInput: Number(precio || 0).toFixed(2),
                                    precioModificado: false,
                                    subtotal,
                                    ivaProducto,
                                    totalProducto,
                                  };
                                }
                                const precio = Number(p.precio) || 0;
                                const cantidad = p.quantity || 1;
                                const totalProducto = precio * cantidad;
                                const subtotal = totalProducto / (1 + (p.iva ?? 0) / 100);
                                const ivaProducto = totalProducto - subtotal;
                                return {
                                  ...p,
                                  precio,
                                  precioInput: precio.toFixed(2),
                                  subtotal,
                                  ivaProducto,
                                  totalProducto,
                                };
                              })
                            );
                          }}
                        />


                      </td>
                      <td className="p-2 text-center">
                        <input
                          type="number"
                          min="1"
                          value={item.quantity}
                          className="w-16 border p-1 text-center rounded"
                          onChange={(e) => {
                            const nuevaCantidad = parseInt(e.target.value) || 1;
                            setProductosPresupuesto((prev) =>
                              prev.map((p, idx) => {
                                if (idx !== i) return p;
                                const fee = Number(presupuestoForm.fee) || 0;
                                const descuento = getQuantityDiscount(p, nuevaCantidad);
                                const precioConDescuento = getDiscountedUnitPrice(p, nuevaCantidad);
                                const precio = p.precioModificado
                                  ? p.precio
                                  : fee > 0
                                    ? precioConDescuento * (1 + fee / 100)
                                    : precioConDescuento;
                                const totalProducto = precio * nuevaCantidad;
                                const subtotal = totalProducto / (1 + (p.iva ?? 0) / 100);
                                const ivaProducto = totalProducto - subtotal;
                                return {
                                  ...p,
                                  precioOriginal: getProductBasePrice(p),
                                  precioConDescuento,
                                  descuentoAplicado: descuento.porcentaje,
                                  precio,
                                  precioInput: Number(precio || 0).toFixed(2),
                                  precioModificado: p.precioModificado,
                                  img: p.img || "",
                                  Descripcion: p.Descripcion || p.nombre || "",
                                  quantity: nuevaCantidad,
                                  codigo: p.codigo || p.Codigo || "",
                                  subtotal,
                                  ivaProducto,
                                  totalProducto,
                                };
                              })
                            );
                          }}
                        />
                      </td>

                      <td className="p-2 text-right">
                        {item.descuentoAplicado > 0 ? `${formatPrice(item.descuentoAplicado)} %` : formatPrice(0)}
                      </td>

                      <td className="p-2 text-right font-semibold">
                        ${item.totalProducto?.toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Totales */}
            <div className="flex flex-col md:flex-row gap-4 items-start">
              <div className="flex-1 flex flex-col">
                <label htmlFor="notas2" className="font-semibold mb-2">
                  Notas:
                </label>
                <textarea
                  id="notas2"
                  className="w-full border rounded-md p-2 resize-none"
                  placeholder="Escribe tus notas..."
                ></textarea>
              </div>

              <div className="w-full md:w-80 flex flex-col">
                <h3 className="text-lg font-semibold text-right mb-2">Total</h3>
                <div className="border border-gray-400 p-4 flex flex-col gap-2">
                  <div className="flex justify-between">
                    <span>Subtotal</span>
                    <span>
                      {Simbolo} {formatPrice(subtotalPresupuesto)}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span>IVA</span>
                    <span>
                      {Simbolo} {formatPrice(ivaPresupuesto)}
                    </span>
                  </div>
                  <div className="flex justify-between font-bold">
                    <span>Total</span>
                    <span>
                      {Simbolo} {formatPrice(totalPresupuesto)}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Botones */}
            <div className="flex justify-end gap-3 mt-4">
              <button
                className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-600"
                onClick={() => setShowPresupuesto(false)}
              >
                Cancelar
              </button>
              <button
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                onClick={generarPresupuesto}
              >
                Grabar Presupuesto
              </button>
            </div>
          </div>
        </div>
      )}





    </div>
  );

};

export default Cart;
